var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13204_131131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0356 18.1427L13.8213 18.7212L14.357 15.4641L20.4963 9.34622C20.5959 9.2458 20.7144 9.16609 20.845 9.1117C20.9755 9.0573 21.1156 9.0293 21.257 9.0293C21.3984 9.0293 21.5385 9.0573 21.669 9.1117C21.7996 9.16609 21.9181 9.2458 22.0177 9.34622L23.1534 10.4819C23.2539 10.5815 23.3336 10.7 23.388 10.8306C23.4424 10.9612 23.4704 11.1012 23.4704 11.2427C23.4704 11.3841 23.4424 11.5241 23.388 11.6547C23.3336 11.7853 23.2539 11.9038 23.1534 12.0034L17.0356 18.1427Z",
    stroke: "#1D3557",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8571 18.6783V21.8926C21.8571 22.1767 21.7442 22.4493 21.5433 22.6502C21.3423 22.8511 21.0698 22.964 20.7856 22.964H10.6071C10.3229 22.964 10.0504 22.8511 9.84946 22.6502C9.64853 22.4493 9.53564 22.1767 9.53564 21.8926V11.714C9.53564 11.4298 9.64853 11.1573 9.84946 10.9564C10.0504 10.7555 10.3229 10.6426 10.6071 10.6426H13.8214",
    stroke: "#1D3557",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13204_131131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(9 8.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesEdit);
export default __webpack_public_path__ + "static/media/salesEdit.12fd7949162fb07667de2863fc13ef10.svg";
export { ForwardRef as ReactComponent };